import type { FunctionComponent } from 'react';

export const CloudUploadIcon: FunctionComponent = () => (
    // biome-ignore lint/a11y/noSvgWithoutTitle: suppressed due to migration
    <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.6665 13.8333L9.99984 10.5M9.99984 10.5L13.3332 13.8333M9.99984 10.5V18M16.6665 14.4524C17.6844 13.6117 18.3332 12.3399 18.3332 10.9167C18.3332 8.38536 16.2811 6.33333 13.7498 6.33333C13.5677 6.33333 13.3974 6.23833 13.3049 6.08145C12.2182 4.23736 10.2119 3 7.9165 3C4.46472 3 1.6665 5.79822 1.6665 9.25C1.6665 10.9718 2.36271 12.5309 3.48896 13.6613"
            stroke="#353E45"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.66667"
        />
    </svg>
);
